import React, { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { usePubSub } from "@videosdk.live/react-sdk";
import { Dropdown } from "react-bootstrap";
const Chat = ({ show, handleClose, user_name }) => {
    const { publish, messages, } = usePubSub("CHAT");

    // State to store the user typed message
    const [message, setMessage] = useState("");

    const handleSendMessage = () => {
        if (message.trim()) {
            publish(message.trim(), { persist: true });
            setMessage("");
        }
    };

    const linkifyText = (text) => {
        const urlRegex = /(\b(?:https?:\/\/|www\.)[^\s]+)/gi;

        return text.split(urlRegex).map((part, index) => {
            if (urlRegex.test(part)) {
                const href = part.startsWith("http") ? part : `https://${part}`;
                return (
                    <a
                        key={index}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#FFD700', textDecoration: 'underline' }}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };



    return (
        <Offcanvas className="custom-offcanvas bg-dark text-light" show={show} onHide={handleClose} placement="end" style={{ borderRadius: '10px' }}>
            <Offcanvas.Header style={{ borderBottom: '1px solid #fff' }} >
                <Offcanvas.Title>Chat</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div style={{ height: '90%', overflowY: 'auto' }}>
                    {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'end', alignItems: 'end', overflowY: 'auto' }}> */}

                    {messages?.map((message) => {

                        return (
                            <div className='video-meet-sec' style={{ overflowWrap: 'anywhere' }}><div
                                className={`col-lg-12 mt-3 d-flex justify-content-${message.senderName === user_name ? "end" : "start"}`}
                                key={message.id}
                            >

                                <div
                                    className={`message px-3 py-0 ${message.senderName == user_name ? "my-msg" : "other-msg"}`}
                                >
                                    <small className='text-light text-wrap '>{message.senderName}</small>
                                    <p className="mb-0 text-light text-wrap">{linkifyText(message.message)}</p>


                                    <span className="msg-date d-flex justify-content-end" style={{ fontSize: '12px' }}>

                                        {message.timestamp
                                            ? new Date(message.timestamp).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })
                                            : ""}
                                    </span>

                                </div>

                            </div></div>

                        );
                    })}
                    {/* </div> */}

                </div>

                <div style={{ height: '10%', width: '100%', display: 'flex', gap: '10px', alignItems: 'end', justifyContent: 'start' }}>
                    <input
                    className="p-1"
                        style={{ width: '85%' }}
                        placeholder='Write your message'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && message.trim()) {
                                handleSendMessage();
                            }
                        }}
                    />
                    <Dropdown>
                        <Dropdown.Toggle className="control-btn">
                            <i className="fa fa-smile-o"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="d-flex p-1">
                            <Dropdown.Item onClick={() => setMessage((prev) => prev + "😂")}>😂</Dropdown.Item>
                            <Dropdown.Item onClick={() => setMessage((prev) => prev + "👍")}>👍</Dropdown.Item>
                            <Dropdown.Item onClick={() => setMessage((prev) => prev + "👏")}>👏</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* <button className='btn btn-primary ms-3 py-1' onClick={handleSendMessage}>Send Message</button> */}
                    <i class="bi bi-send-fill" onClick={handleSendMessage} style={{ width: '15%', fontSize: '1.8rem' }}></i>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default Chat